import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import MainFormsCreateClass from "./components/MainFormsCreateClass";
import { InputValueNewClassRoom } from "../../../domains/class-room";
import { Typography } from "@mui/material";
import StepperCustom from "../../../components/step/Stepper";
import ListStudent from "./ListStudent";
import { icons } from "../../../assets/icons/icons";
import { classRoomApi } from "../../../api/class-room/class-room.api";
import { advisorTypeApi } from "../../../api/advisor-type/advisor-type.api";
import { degreeApi } from "../../../api/degree/degree.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
type Props = {};

const UpdateClassRoom: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const is_view_only = queryParams.get("view-only");
  const [tabStep, setTebStep] = useState(0);
  const { id } = useParams();

  const [isCanEdit, setIsCanEdit] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<any[]>([]);

  const [dataDegree, setDataDegree] = useState<any[]>([]);
  const [dataFaculty, setDataFaculty] = useState<any[]>([]);

  const [inputValue, setInputValue] = useState<InputValueNewClassRoom>({
    degree: 0,
    faculty: 0,
    start_academic_year: 0,
    end_academic_year: 0,
    class: "",
    advisor: [], // This is initially an empty array but will be populated with Advisor objects
    evaluation_form_type: 0,
    id_academic_year: null
  });

  const [singleRawData, setSingleRawData] = useState<any[]>([]);
  const [studentList, setStudentList] = useState<any[]>([]);
  const [advisorType, setAdvisorType] = useState<any[]>([]);

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);


  const handleClearError = () => setErrorMessage([]);
  const getDataDegree = async () => {
    await degreeApi.getDegree().then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataDegree(data.data);
      } else {
        setDataDegree([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  const getDataFaculty = useCallback(async () => {
    await facultyApi.listFaculty(inputValue.degree ? +inputValue.degree : undefined).then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataFaculty(data.data);
      } else {
        setDataFaculty([]);
      }
    }).catch((err) => {
      console.log(err)
    })

  }, [inputValue.degree])

  useEffect(() => {
    getDataDegree();
  }, []);

  useEffect(() => {
    getDataFaculty();
  }, [getDataFaculty])

  const allStep = [
    {
      name: "ข้อมูลชั้นเรียน",
      isAccept: false,
      icon: (
        <img
          src={tabStep === 0 ? icons.book_white : icons.book_black}
          alt="book"
          style={{ cursor: "pointer" }}
        />
      ),
    },
    {
      name: "ข้อมูลนักศึกษาภายในชั้นเรียน",
      isAccept: false,
      icon: (
        <img
          src={tabStep === 1 ? icons.folder_white : icons.folder_black}
          alt="folder"
          style={{ cursor: "pointer" }}
        />
      ),
    },
  ];

  const getSingleClassRoom = async (id: number) => {
    const res = await classRoomApi.getClassRoomById(id);
    const data = res.data;
    if (data.status < 300) {
      // console.log("data.data", data.data);
      // setInputValue(data.data);
      setInputValue({
        degree: data.data?.id_degree ?? null,
        faculty: data.data?.id_faculty ?? null,
        start_academic_year: data.data?.year_start ?? null,
        end_academic_year: data.data?.year_end ?? null,
        id_academic_year: data?.data?.id_academic_year,
        class: data.data?.room ?? null,
        advisor:
          data.data?.class_room_employees?.length > 0 ?
            data.data?.class_room_employees &&
            data.data?.class_room_employees.length > 0 &&
            data.data?.class_room_employees
              .filter((raw: any) => raw?.id_class_room_employee)
              .map((item: any) => {
                // const advisorTypeName =
                //   (advisorType.length > 0 &&
                //     advisorType.find((type: any) => type.id === item.advisor_type)
                //       ?.name) ||
                //   "";
                return {
                  id_class_room_employee: item?.id_class_room_employee ?? null,
                  employee_id: item?.id_employee ?? 0,
                  employee_name: `${item?.first_name} ${item?.last_name}`,
                  advisor_type: 0,
                  advisor_type_name: item?.advisor_type ?? "",
                };
              }) : [],
        evaluation_form_type: data.data?.id_advisor_form ?? null,
      });
      setStudentList(data.data.student_list);

      setSingleRawData(
        data.data?.class_room_employees &&
        data.data?.class_room_employees.length > 0 &&
        data.data?.class_room_employees
          .filter((raw: any) => raw?.id_class_room_employee !== null)
          .map((item: any) => {
            return {
              id_class_room_employee: item?.id_class_room_employee ?? null,
              employee_id: item?.id_employee ?? 0,
              employee_name: `${item?.first_name} ${item?.last_name}`,
              advisor_type: 0,
              advisor_type_name: item?.advisor_type ?? "",
            };
          })
      );
    } else {
      setInputValue({
        degree: 0,
        faculty: 0,
        start_academic_year: 0,
        end_academic_year: 0,
        class: "",
        id_academic_year: null,
        advisor: [], // This is initially an empty array but will be populated with Advisor objects
        evaluation_form_type: 0,
      });
    }
  };

  const getAdvisorType = async () => {
    let query: any = {
      page: 1,
      limit: 10000,
    };

    const res = await advisorTypeApi.getAllAdvisorType(query);
    const data = res.data;
    if (data.status < 300) {
      setAdvisorType(data.data.items);
    } else {
      setAdvisorType([]);
    }
  };

  useEffect(() => {
    getAdvisorType();
  }, []);

  useEffect(() => {
    if (id) {
      getSingleClassRoom(parseInt(id));
    }
  }, [id]);

  const validateForm = () => {
    const errors: string[] = [];

    // Check if required fields are empty
    if (!inputValue.degree) {
      errors.push("degree");
    }

    if (!inputValue.faculty) {
      errors.push("faculty");
    }

    if (!inputValue.start_academic_year) {
      errors.push("start_academic_year");
    }

    if (!inputValue.end_academic_year) {
      errors.push("end_academic_year");
    }

    if (!inputValue.class) {
      errors.push("class");
    }

    if (!inputValue.evaluation_form_type) {
      errors.push("evaluation_form_type");
    }

    setErrorMessage(errors);

    // If there are no errors, return true
    return errors.length === 0;
  };

  // console.log("singleRawData", singleRawData);

  const handleUpdate = async (dataBody: any, idClassRoom: number) => {
    if (validateForm() && idClassRoom) {
      try {
        dispatch(unsetLoading());

        const degree_name = dataDegree.find(
          (item) => item.id_degree === inputValue.degree
        );

        const faculty_name = dataFaculty.find(
          (item) => item.id_faculty === inputValue.faculty
        );

        const dataAdvisor = [
          // Update existing advisors or mark as inactive

          ...singleRawData.filter((x) => x?.employee_id).map((raw: any) => {
            const matchingAdvisor = inputValue.advisor.find(
              (item: any) =>
                item.id_class_room_employee === raw.id_class_room_employee
            );
            return {
              id_class_room_employee: raw.id_class_room_employee ?? 0,
              id_employee: raw.employee_id ?? 0,
              advisor_type: matchingAdvisor?.advisor_type_name ?? '',
              status: matchingAdvisor ? "active" : "inactive",
            };
          }),

          // Add new advisors
          ...inputValue.advisor
            .filter(
              (item: any) =>
                !singleRawData.some(
                  (raw: any) =>
                    raw.id_class_room_employee === item.id_class_room_employee
                )
            )
            .map((item: any) => ({
              id_class_room_employee: item?.id_class_room_employee ?? 0,
              id_employee: item?.employee_id,
              advisor_type: item?.advisor_type_name,
              status: "active",
            })),
        ];
        const response = await classRoomApi.updateClassRoom(idClassRoom, {
          class_room: {
            id_class_room: idClassRoom,
            id_degree: inputValue.degree,
            degree_name: degree_name.degree_name,
            id_faculty: inputValue.faculty,
            faculty_name: faculty_name.faculty_name,
            year_start: inputValue.start_academic_year,
            year_end: inputValue.end_academic_year,
            room: inputValue.class,
            status: "active",
            id_advisor_form: inputValue.evaluation_form_type,
          },
          class_room_employee: dataAdvisor,
        });
        if (response.status < 300) {
          alertSuccess(
            "บันทึกชั้นเรียน",
            "บันทึกชั้นเรียน เรียบร้อยแล้ว",
            undefined,
            () => {
              navigate(routeName.cms.ManageClassRoom);
              setIsCanEdit(false);
            }
          );
        }
      } catch (error) {
        alertError("บันทึกชั้นเรียน ไม่สำเร็จ");
      } finally {
        dispatch(unsetLoading());
      }
    }
  };

  // console.log("inputValue", inputValue);

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: "จัดการชั้นเรียน",
            key: "1",
            pathName: routeName.cms.ManageClassRoom,
          },
          {
            name: "ข้อมูลชั้นเรียน",
            key: "2",
            pathName: routeName.cms.UpdateClassRoom,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">ข้อมูลชั้นเรียน</Typography>
      </section>

      {is_view_only === "true" && (
        <>
          <section
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "24px",
            }}
          >
            <StepperCustom
              step={tabStep}
              setStep={setTebStep}
              stepLabel={allStep}
              view={true}
            />
          </section>
        </>
      )}

      {tabStep === 0 ? (
        <section className="w-full mt-4">
          <MainFormsCreateClass
            inputValue={inputValue}
            handleClearError={handleClearError}
            setInputValue={setInputValue}
            isCanEdit={isCanEdit}
            action={"create"}
            isViewOnly={is_view_only === "true"}
            errorMessage={errorMessage}
          />
        </section>
      ) : tabStep === 1 ? (
        <ListStudent dataStudent={studentList} />
      ) : null}

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <ButtonOutlined
          onClick={() => {
            navigate(routeName.cms.ManageClassRoom);
          }}
          mode="del"
          buttonName="ยกเลิก"
          btnProps={{
            width: "125px",
            margin: "12px",
          }}
        />
        {is_view_only === "false" && (
          <>
            {isCanEdit ? (
              <ButtonPrimary
                onClick={() => {
                  if (id) {
                    handleUpdate(inputValue, parseInt(id));
                  }
                }}
                mode="success"
                buttonName="ยืนยัน"
                btnProps={{
                  width: "125px",
                  margin: "12px",
                }}
              />
            ) : (
              <ButtonPrimary
                onClick={() => {
                  setIsCanEdit(true);
                }}
                buttonName="แก้ไข"
                btnProps={{
                  width: "125px",
                  margin: "12px",
                }}
              />
            )}
          </>
        )}
      </section>
    </div>
  );
};

export default UpdateClassRoom;
